var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isI18n
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "card-item mt-6" },
              [
                _c("CollectionButtons", {
                  attrs: { clients: _vm.clients },
                  on: {
                    filters: function ($event) {
                      _vm.filters.isModalVisible = true
                    },
                  },
                }),
                _c(
                  "b-field",
                  { staticClass: "m-5" },
                  [
                    _c("FindEntitiesInput", {
                      staticClass: "search-clients",
                      attrs: {
                        placeholder: "Buscar cliente",
                        expanded: true,
                        finder: _vm.finder,
                      },
                      on: {
                        select: function ($event) {
                          _vm.clickedOnClient(
                            $event,
                            _vm.checkUserFeature(
                              "element.collection.button.gestionar"
                            ) && !$event.defaultingCollectionUserId
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("div", [
                  _c("h5", { staticClass: "has-text-centered" }, [
                    _vm._v(" " + _vm._s(_vm.$t("filterText")) + " "),
                    _c("span", { staticClass: "has-text-weight-bold" }, [
                      _vm._v(
                        _vm._s(_vm.numberOfDocuments) +
                          " cliente" +
                          _vm._s(_vm.clients.length > 1 ? "s" : "")
                      ),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("withLate")) + " "),
                    _c("span", { staticClass: "has-text-weight-bold" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.filteredClients.length > 0
                              ? `${_vm.$t("showing")} ${
                                  _vm.filteredClients.length
                                }`
                              : _vm.$t("withOutResult")
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "container" },
                  [
                    _vm.isLoading ? _c("Spinner") : _vm._e(),
                    _vm.clients.length === 0 && !_vm.isLoading
                      ? _c("Message", {
                          attrs: {
                            message: _vm.mainMessage.message,
                            icon: _vm.mainMessage.icon,
                            "as-card": false,
                          },
                        })
                      : _vm._e(),
                    !_vm.isLoading
                      ? _c(
                          "div",
                          {
                            staticClass: "default-items",
                            attrs: {
                              id: "clients-list",
                              "data-cy": "clients-list",
                            },
                          },
                          _vm._l(_vm.filteredClients, function (client) {
                            return _c(
                              "div",
                              {
                                key: client._id,
                                staticClass:
                                  "card-item shadowless default-item-info has-text-centered",
                                class: [
                                  `${client.totalNumberOfDefaultingPayments}-defaulting-payments`,
                                  !client.defaultingCollectionUserId
                                    ? ""
                                    : _vm.currentUserId ===
                                      client.defaultingCollectionUserId
                                    ? "managed-by-current-user"
                                    : "managed-by-another-user",
                                  client.numberOfDefaultingDays >= 90
                                    ? "ninety-days"
                                    : client.numberOfDefaultingDays >= 60
                                    ? "sixty-days"
                                    : client.numberOfDefaultingDays >= 30
                                    ? "thirty-days"
                                    : "healthy-days",
                                ],
                                attrs: { id: `client-${client._id}` },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "default-item-numbers" },
                                  [
                                    _c(
                                      "b-tooltip",
                                      {
                                        staticClass: "default-item-days",
                                        attrs: {
                                          label: _vm.$t("lateDays"),
                                          "data-cy": "default-item-days",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-calendar-alt content-title med-size-text",
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "big-size-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                client.numberOfDefaultingDays
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-tooltip",
                                      {
                                        staticClass: "default-item-operations",
                                        attrs: {
                                          label: _vm.$t("lateOperations"),
                                          "data-cy": "default-item-operations",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-home content-title med-size-text",
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "big-size-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                client.defaultingOperations
                                                  .length
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-tooltip",
                                      {
                                        staticClass: "default-item-fees",
                                        attrs: {
                                          label: _vm.$t("lateFees"),
                                          "data-cy": "default-item-fees",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-layer-group content-title med-size-text",
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "big-size-text" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  client.totalNumberOfDefaultingPayments
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "default-item-client med-size-text",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "content-title" },
                                      [
                                        _vm._v(
                                          _vm._s(client.name) +
                                            " " +
                                            _vm._s(client.lastName)
                                        ),
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatIdNumber(client.idNumber)
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "default-item-manage med-size-text",
                                    attrs: { "data-cy": "default-item-manage" },
                                  },
                                  [
                                    _vm.checkUserFeature(
                                      "element.collection.button.gestionar"
                                    ) &&
                                    (!client.defaultingCollectionUserId ||
                                      _vm.currentUserId ===
                                        client.defaultingCollectionUserId)
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button manage-button is-button-secondary is-rounded",
                                            attrs: {
                                              disabled: !_vm.checkUserFeature(
                                                "element.collection.button.gestionar"
                                              ),
                                              "data-cy": "manage-button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickedOnClient(
                                                  client,
                                                  !client.defaultingCollectionUserId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("manage")) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button manage-button is-button-secondary is-rounded",
                                            attrs: {
                                              disabled: !_vm.checkUserFeature(
                                                "element.collection.button.ver-cliente"
                                              ),
                                              "data-cy": "manage-button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickedOnClient(
                                                  client,
                                                  false
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("justSee")) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                !_vm.isLoading
                  ? _c("creditu-pagination", {
                      attrs: {
                        "page-number": _vm.pageNumber,
                        size: "is-small",
                        "documents-per-page": _vm.documentsPerPage,
                        "items-name": "Clientes",
                        total: _vm.numberOfDocuments,
                        "range-before": 1,
                        "range-after": 1,
                        "documents-per-page-options": [5, 10, 20, 50, 10000],
                      },
                      on: {
                        "update:pageNumber": function ($event) {
                          _vm.pageNumber = $event
                        },
                        "update:page-number": function ($event) {
                          _vm.pageNumber = $event
                        },
                        "update:documentsPerPage": function ($event) {
                          _vm.documentsPerPage = $event
                        },
                        "update:documents-per-page": function ($event) {
                          _vm.documentsPerPage = $event
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("CollectionFilters", {
              model: {
                value: _vm.filters,
                callback: function ($$v) {
                  _vm.filters = $$v
                },
                expression: "filters",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }